import React from 'react'
import Table from '../../components/common/Table'
import { ClientDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'

interface ClientTableProps {
  data: ClientDTO[];
  handleEdit: (row: ClientDTO) => void;
  handleDelete: (row: ClientDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const ClientTable: React.FC<ClientTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[

        {
          label: "Company Name",
          key: "companyName",
        },

        {
          label: "Contact Person",
          key: "contactPerson",
        },

        {
          label: "Number",
          key: "number",
        },

        {
          label: "Email",
          key: "email",
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ClientTable;
